module.exports = __webpack_public_path__ + "img/110_3.d4e45f90.png";